import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tabletS, mobile, mobileS } from '@/utils/media'
import { mq } from '@/utils/helpers'
import { Link } from 'gatsby'
import Headline from '@/components/app/Headline'
import Typography from '@/components/common/Typography'
import Bg from '@/components/app/Bg'
import Features from '@/components/svg/Features'
import LinkButton1 from '@/components/common/LinkButton1'

const FeatureLead = props => {
  return (
    <Root {...props}>
      <Head>
        <Title theme={props.theme}>
          幅広い機能で<br />
          <strong>すべてを一元管理</strong>
        </Title>
      </Head>
      <Main>
        <Body variant="body1">
          クラウド環境で基幹業務管理ための機能を幅広く提供しています。<br />痒い所に手が届く、きめ細かい仕組みが搭載されております。
        </Body>
        <Chart>
          <Chart_Content />
        </Chart>
      </Main>
      <Foot>
        <MoreButton to="/feature/" component={Link} color="primary">機能一覧を見る</MoreButton>
      </Foot>
    </Root>
  )
}

const Root = styled.div`
  padding: 100px 0 120px;
  @media ${mq.and(mobile)} {
    padding: 48px 0 64px;
  }
`

const Head = styled.div``

const Title = styled(Headline)`
  strong {
    color: ${props => props.theme.primary.base};
  }
  @media ${mq.and(mobileS)} {
    br:nth-of-type(2) {
      display: none;
    }
  }
`

const Main = styled.div`
  margin-top: 40px;
  @media ${mq.and(mobile)} {
    margin-top: 32px;
  }
`

const Body = styled(Typography)`
  margin: 0 auto;
  max-width: ${layouts.defs.contentMaxWidth.base}px;
  text-align: center;
  @media ${mq.and(tabletS)} {
    text-align: left;
    max-width: ${layouts.defs.contentMaxWidth.small}px;
    br {
      display: none;
    }
  }
  @media ${mq.and(mobile)} {
    text-align: left;
    br {
      display: none;
    }
  }
`

const Chart = styled(Bg)`
  margin: 64px auto;
  max-width: 996px;
  padding: 0 38px;
  @media ${mq.and(mobile)} {
    margin-top: 48px;
    margin-left: ${layouts.defs.pad.mobile * -1}px;
    margin-right: ${layouts.defs.pad.mobile * -1}px;
    padding-left: ${layouts.defs.pad.mobile}px;
    padding-right: ${layouts.defs.pad.mobile}px;
  }
`

const Chart_Content = styled(Features)`
  width: 100%;
  max-width: 772px;
  margin: 0 auto;
`

const Foot = styled.div`
  margin-top: 48px;
  display: flex;
  justify-content: center;
`

const MoreButton = styled(LinkButton1)`
  width: 278px;
  @media ${mq.and(mobileS)} {
    width: 100%;
  }
`

export default ThemeConsumer(FeatureLead)
